var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8128 2.29217C20.5773 1.4053 19.8833 0.706825 19.0022 0.469787C17.405 0.0390625 11.0008 0.0390625 11.0008 0.0390625C11.0008 0.0390625 4.5965 0.0390625 2.99934 0.469787C2.1182 0.706862 1.42423 1.4053 1.18869 2.29217C0.760742 3.89969 0.760742 7.25361 0.760742 7.25361C0.760742 7.25361 0.760742 10.6075 1.18869 12.215C1.42423 13.1019 2.1182 13.7713 2.99934 14.0083C4.5965 14.4391 11.0008 14.4391 11.0008 14.4391C11.0008 14.4391 17.405 14.4391 19.0022 14.0083C19.8833 13.7713 20.5773 13.1019 20.8128 12.215C21.2408 10.6075 21.2408 7.25361 21.2408 7.25361C21.2408 7.25361 21.2408 3.89969 20.8128 2.29217ZM8.90619 10.2987V4.2085L14.2589 7.25369L8.90619 10.2987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.8c42af2835aa0079bb528a889965899a.svg";
export { ForwardRef as ReactComponent };